import { formatCreditBalance } from '@/lib/formatCredits';

// Stable bands keep the same model's indicator consistent across all views.
export function getModelPricing(model) {
  const cost = Number(model?.creditCosts?.baseCost);
  if (model?.creditCosts?.isEnabled === false || !Number.isFinite(cost) || cost <= 0) return null;
  const tier = cost <= 3 ? 1 : cost <= 10 ? 2 : cost <= 30 ? 3 : 4;
  const credits = `${formatCreditBalance(cost)} ${cost === 1 ? 'credit' : 'credits'}`;
  return { cost, credits, startingLabel: `Starts at ${credits}`, tier, symbols: '$'.repeat(tier) };
}
